import React from 'react';
import { FiCompass } from 'react-icons/fi';
import './tour.css';

// Header button that replays a page's guided tour. Label hides on narrow screens.
export default function TourButton({ onClick, label = 'Tour', className = '' }) {
  return (
    <button type="button" className={`nb-tour-trigger ${className}`.trim()} onClick={onClick} aria-label="Take the guided tour">
      <FiCompass aria-hidden="true" /> <span>{label}</span>
    </button>
  );
}
